import LargeTextWithLine from './LargeTextWithLine';

export default LargeTextWithLine;